module.exports = __webpack_public_path__ + "media/src/images/proctored_icons/specific_websites-1a3c4b86a11a208947e0abec32777b6c.svg";